import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, Tag, MapPin } from "lucide-react";
import { motion } from "framer-motion";

const TABS = [
  { to: "/", label: "Inicio", icon: Home, testid: "nav-inicio", end: true },
  { to: "/categorias", label: "Explorar", icon: LayoutGrid, testid: "nav-explorar" },
  { to: "/ofertas", label: "Ofertas", icon: Tag, testid: "nav-ofertas" },
  { to: "/cerca", label: "Cerca", icon: MapPin, testid: "nav-cerca" },
];

export default function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 z-50 w-full max-w-md glass border-t border-black/5 pb-safe">
      <div className="flex items-center justify-around px-2 pt-2">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            data-testid={t.testid}
            className="relative flex flex-1 flex-col items-center gap-1 py-1.5"
          >
            {({ isActive }) => (
              <>
                <div className="relative flex h-9 w-9 items-center justify-center">
                  {isActive && (
                    <motion.div
                      layoutId="nav-pill"
                      className="absolute inset-0 rounded-full bg-[#1A1A1A]"
                      transition={{ type: "spring", stiffness: 400, damping: 30 }}
                    />
                  )}
                  <t.icon
                    size={20}
                    className={`relative z-10 ${isActive ? "text-white" : "text-[#5C5C5C]"}`}
                    strokeWidth={2.2}
                  />
                </div>
                <span
                  className={`text-[10px] font-bold tracking-wide ${
                    isActive ? "text-[#1A1A1A]" : "text-[#9c9c9c]"
                  }`}
                >
                  {t.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
